import {
  type Dispatch,
  type SetStateAction,
  useCallback,
  useState,
} from "react";

export type UseBooleanReturn = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  value: boolean;
  setValue: Dispatch<SetStateAction<boolean>>;
  setTrue: () => void;
  setFalse: () => void;
  toggle: () => void;
};

export function useBoolean(defaultValue = false): UseBooleanReturn {
  if (typeof defaultValue !== "boolean") {
    throw new Error("defaultValue must be `true` or `false`");
  }
  const [value, setValue] = useState(defaultValue);

  const setTrue = useCallback(() => {
    setValue(true);
  }, []);

  const setFalse = useCallback(() => {
    setValue(false);
  }, []);

  const toggle = useCallback(() => {
    setValue((x) => !x);
  }, []);

  return {
    value,
    setValue,
    setTrue,
    setFalse,
    toggle,
    isOpen: value,
    setIsOpen: setValue,
  };
}
